import { render, staticRenderFns } from "./FormCitizenship.vue?vue&type=template&id=5fb73580&"
import script from "./FormCitizenship.vue?vue&type=script&lang=ts&"
export * from "./FormCitizenship.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports